import { useEffect, useState } from "react";
import { BASE_URL } from "~/lib/config/constants";
import { getConfig } from "~/lib/config/env";

export default function BuildNumbers() {
  const [apiVersion, setApiVersion] = useState<string>("");

  useEffect(() => {
    const fetchApiVersion = async () => {
      try {
        const res = await fetch(`${BASE_URL()}/api/v1/meta/info`);
        if (res.ok) {
          const data = await res.json();
          const version =
            data.result?.version ||
            data.result?.Version ||
            data.version ||
            data.Version ||
            "";
          setApiVersion(version);
        }
      } catch {
        // No offline fallback
      }
    };
    fetchApiVersion();
  }, []);

  const clientVersion = getConfig().version;

  return (
    <div className="fixed bottom-0 right-4 flex gap-4 text-[10px] text-neutral-300 z-[9999] pointer-events-none select-none">
      {clientVersion && <span>c: {clientVersion}</span>}
      {apiVersion && <span>a: {apiVersion}</span>}
    </div>
  );
}
